import {
  TBroadcastScheduleProgramContextState,
  useBroadcastScheduleProgram,
} from '@/features/broadcast-schedule-program/context/BroadcastScheduleProgramContext';
import { isPresenceFormOnScreen } from '@/features/broadcast-schedule-program/helpers/is-presence-form-on-screen';

type UseGoNextOnEndedParams = {
  hasNextItem: boolean;
  handleNextItem: () => void;
  videoControlRef: TBroadcastScheduleProgramContextState['videoControlRef'];
  skip?: boolean;
};

const PLAY_NEXT_DELAY_MS = 100;

export function useGoNextOnEnded({
  hasNextItem,
  handleNextItem,
  videoControlRef,
  skip = false,
}: UseGoNextOnEndedParams) {
  const { formBox, pinnedId, isGlobalView } = useBroadcastScheduleProgram();

  // Loading the next item while a presence form is on screen would save the presence
  // in the wrong segment.
  return () => {
    if (skip || isPresenceFormOnScreen(formBox, pinnedId, isGlobalView)) return;
    if (!hasNextItem) return;

    handleNextItem();
    setTimeout(() => {
      videoControlRef.current?.play();
    }, PLAY_NEXT_DELAY_MS);
  };
}
